import React, { useState, useRef, useEffect } from 'react';
import { 
  X,
  ChevronLeft
} from 'lucide-react';
import { Player } from '@lordicon/react';
import ScrollReveal from 'scrollreveal';
import styles from './Services.module.css';
// ודא שאתה מייבא את כל האייקונים הדרושים
import camera from "../../icons/wired-outline-61-camera-hover-flash.json"
import social from "../../icons/wired-outline-962-social-media-marketing-hover-pinch.json"
import ads from "../../icons/wired-outline-1028-web-advertising-hover-pinch.json"
import adds from "../../icons/wired-outline-152-bar-chart-arrow-hover-growth.json"
import chess from "../../icons/wired-outline-1477-chessboard-hover-pinch.json"
import brand from "../../icons/wired-outline-1018-signature-sig-hover-pinch.json"
import lecture from "../../icons/wired-outline-689-speaker-lecturer-female-hover-pinch (1).json"
import Button from '../button/Button';

const ServicesShowcase = () => {
  const [selectedService, setSelectedService] = useState(null);
  
  // Create refs for each player
  const playerRefs = {
    1: useRef(null),
    2: useRef(null),
    3: useRef(null),
    4: useRef(null),
    5: useRef(null),
    6: useRef(null),
    7: useRef(null),
    8: useRef(null)
  };

  const services = [
    {
      id: 1,
      icon: social,
      title: "ניהול סושיאל VIP",
      description: "ניהול מלא של הנוכחות הדיגיטלית שלך",
      bgClass: styles.bgImage1,
      process: [
        "שיחת היכרות ואיפיון לעסק כדי להבין את המטרות וקהל היעד",
        "בניית אסטרטגיית תוכן ותסריטים לצילומים",
        "יום צילום ליצירת תוכן איכותי ומדויק",
        "יצירת 12 פוסטים שיעלו במהלך החודש",
        "העלאת סטורי ביום שבו עולים פוסטים",
        "העלאה של התכנים לרשתות ומענה ראשוני לתגובות",
        "שילוב אוטומציות לנתינת ערך לקהל היעד שלך",
        "דוח חודשי עם מעקב ותובנות לשיפור",
        "ליווי מלא והתייעצות בקבוצת ווטסאפ משותפת"
      ]
    },
    {
      id: 2,
      icon: camera,
      title: "ימי צילום לרשתות",
      description: "צילומי תוכן איכותיים שמיועדים לרשתות חברתיות",
      bgClass: styles.bgImage2,
      process: [
        "איפיון והכרה עם העסק כדי ליצור תסריטים",
        "פגישת אסטרטגיה ואישור קריאייטיב",
        "יום צילום בעסק שלך או בלוקיישן נבחר",
        "צילום סרטונים ותמונות אווירה לעסק",
        "עריכה מקצועית של הסרטונים",
        "קבלת גלריה מסודרת של הסרטונים וחומרי הגלם"
      ]
    },
    {
      id: 3,
      icon: chess,
      title: "מיתוג שיווקי לעסק מתחיל",
      description: "חבילה בסיסית של מיתוג, בחירת צבעים וקאברים ובניית אסטרטגיה של פרסומים באופן עצמאי",
      bgClass: styles.bgImage3,
      process: [
        "איפיון העסק ופגישת ייעוץ ואסטרטגיה",
        "נלמד על כל הדברים החשובים לפני תחילת פרסומים",
        "נלמד איך להצליח ליצור תוכן בקלות גם בהתחלה",
        "נעבור על רשתות חשובות שצריך להקים ולפרסם בהם",
        "נעבור על תוכנות ודברים שיקלו עלינו בשיווק שלנו",
        "קבלת תבנית לעיצוב קאברים לפוסטים והיילייטס"
      ]
    },
    {
      id: 4,
      icon: ads,
      title: "קמפיינים ממומנים",
      description: "פרסום ממוקד שמביא תוצאות",
      bgClass: styles.bgImage4,
      process: [
        "הגדרת מטרות ותקציב פרסום מתאים",
        "בדיקה מי הקהל שהכי נכון לך לפרסום",
        "יצירת מודעות ותוכן מושך שמניע לפעולה",
        "הקמה של קמפיינים בפייסבוק ובאינסטגרם",
        "בדיקה יומיומית של ביצועים ושיפורים",
        "דוח ביצועים עם מסקנות והמלצות"
      ]
    },
    {
      id: 5,
      icon: brand,
      title: "עיצוב גרפי ומיתוג",
      description: "עיצובים שמדברים את השפה שלך",
      bgClass: styles.bgImage5,
      process: [
        "היכרות עם סגנון המותג שלך והערכים שמובילים אותך",
        "בחירת קו עיצובי שמתאים לאופי העסק",
        "עיצוב תבניות לפוסטים וסטוריז לשימוש קבוע",
        "יצירת חומרים גרפיים כמו באנרים וכרטיסי ביקור",
        "התאמה מלאה לעיצוב של כל פלטפורמה",
        "שמירה על מראה אחיד וזכיר בכל מקום"
      ]
    },
    {
      id: 6,
      icon: adds,
      title: "ייעוץ וליווי שיווקי",
      description: "מנטורית שיווקית אישית לעסק שלך",
      bgClass: styles.bgImage6,
      process: [
        "פגישות אישיות קבועות לפי הצורך שלך",
        "בדיקה מה עובד ומה דורש שינוי בשיווק שלך",
        "הכוונה ברורה מה לעשות בכל שלב",
        "עזרה בבחירת מהלכים שיווקיים נכונים",
        "בניית תוכנית עבודה פשוטה וברורה",
        "תמיכה שוטפת בווטסאפ כשצריך"
      ]
    },
    {
      id: 7,
      icon: lecture,
      title: "הרצאות לבעלי עסקים",
      description: "הרצאה מעשירה לתלמידים ולקוחות של בעלי עסקים",
      bgClass: styles.bgImage1,
      process: [
        "הרצאה עניינית שנותנת כלים לשיווק עצמי",
        "מעבר על כל האפליקציות שיקלו על השיווק של בעל העסק",
        "דוגמאות ורעיונות ליצירת תוכן",
        "לאן השיווק הולך בשנה הקרובה",
        "שימוש בפיצ'רים חדשניים לשיווק מדוייק"
      ]
    },
    {
      id: 8,
      icon: adds,
      title: "מגוון קורסים",
      description: "בקרוב...",
      bgClass: styles.bgImage2,
      process: [
        "בקרוב יעלו קורסים חדשים ומרתקים",
        "המתינו לעדכונים נוספים"
      ]
    }
  ];

  const handleComplete = (id) => {
    setTimeout(() => {
      playerRefs[id]?.current?.playFromBeginning();
    }, 2500);
  };

  // Play animations on mount
  useEffect(() => {
    Object.values(playerRefs).forEach(ref => {
      ref?.current?.playFromBeginning();
    });
  }, []);

  // ScrollReveal effect
  useEffect(() => {
    ScrollReveal().reveal(`.${styles.icon}`, {
      duration: 1000,
      distance: "100px",
      origin: "left",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
  }, []);

  const handleWhatsAppClick = (serviceTitle) => {
    const phoneNumber = "972508727802";
    const message = `היי נטלי, הגעתי מהדף שלך, אשמח לשמוע עוד על ${serviceTitle}`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const ServiceOverlay = ({ service, onClose }) => {
    const overlayPlayerRef = useRef(null);
    
    useEffect(() => {
      if (service) {
        overlayPlayerRef?.current?.playFromBeginning();
      }
    }, [service]);

    const handleOverlayComplete = () => {
      setTimeout(() => {
        overlayPlayerRef?.current?.playFromBeginning();
      }, 2500);
    };

    if (!service) return null;

    return (
      <div 
        className={styles.overlayBackdrop}
        onClick={onClose}
      >
        <div 
          className={styles.overlayContent}
          onClick={(e) => e.stopPropagation()}
        >
          <button 
            className={styles.overlayClose}
            onClick={onClose}
            aria-label="סגור"
          >
            <X size={24} />
          </button>
          
          <div className={styles.overlayHeader}>
            <div className={styles.overlayIcon}>
              <Player 
                icon={service.icon} 
                ref={overlayPlayerRef}
                size="100%"
                onComplete={handleOverlayComplete}
              />
            </div>
            <h3 className={styles.overlayTitle}>{service.title}</h3>
            <p className={styles.overlayDescription}>{service.description}</p>
          </div>

          <div className={styles.overlayProcess}>
            <h4 className={styles.processTitle}>התהליך שלנו:</h4>
            <div className={styles.processSteps}>
              {service.process.map((step, index) => (
                <div key={index} className={styles.processStep}>
                  <div className={styles.stepNumber}>{index + 1}</div>
                  <div className={styles.stepContent}>
                    <ChevronLeft className={styles.stepArrow} size={16} />
                    <p className={styles.stepText}>{step}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button 
            className={styles.overlayCta}
            onClick={() => handleWhatsAppClick(service.title)}
          >
            {service.id === 2 ? 'אני רוצה לקבוע יום צילום' : 
             service.id === 3 ? 'אני רוצה להתחיל את העסק שלי נכון' :
             service.id === 7 ? 'אני רוצה לקבוע הרצאה' :
             'בואו נתחיל לעבוד ביחד'}
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.title}>
              <div className={styles.titleHighlight}>השירותים שלי</div>
            </div>
            <p className={styles.subtitle}>
        לחצו על כל שירות כדי לקבל עוד פרטים על התהליך המלא
            </p>
          </div>

          <div className={styles.grid}>
            {services.map((service) => {
              return (
                <div 
                  key={service.id} 
                  className={`${styles.card} ${service.bgClass}`}
                  onClick={() => setSelectedService(service)}
                >
                  <div className={styles.icon}>
                    <Player 
                      icon={service.icon} 
                      ref={playerRefs[service.id]}
                      size="100%"
                      onComplete={() => handleComplete(service.id)}
                    />
                  </div>
                  <h3 className={styles.cardTitle}>{service.title}</h3>
                  <p className={styles.description}>{service.description}</p>
                  <button 
                    className={styles.button}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedService(service);
                    }}
                  >
                    על התהליך
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {selectedService && (
        <ServiceOverlay 
          service={selectedService} 
          onClose={() => setSelectedService(null)} 
        />
      )}
      <Button text="נטלי, אני רוצה לדעת מה מתאים לי יחד איתך!"/>
    </>
  );
};

export default ServicesShowcase;